import { requisicaoService } from '@/services/requisicaoService';
// import router from '../../router'
import Requisicao from '@/domain/Requisicao';
import ItemRequisicao from '@/domain/ItemRequisicao';

const state = {
  requisicoes: [],
  selected: []
};

const getters = {
  requisicoes: state => state.requisicoes,
  requisicoesSelected: state => state.selected
};

const actions = {
  async sendRequisicoesAPI({ commit, dispatch }, requisicoes) {
    if (requisicoes.length) {
      // const promises = [];

      // requisicoes.forEach(requisicao => promises.push(dispatch('sendRequisicaoAPI', requisicao)));

      for (const requisicao of requisicoes) {
        await dispatch('sendRequisicaoAPI', requisicao);
      }

      commit('SHOW_SNACKBAR', { text: 'Operação concluída com sucesso', status: 'success' });

      // Promise.all(promises)
      //   .then(() => commit('SHOW_SNACKBAR', { text: 'Operação concluída com sucesso', status: 'success' }))
      //   .catch(() => commit('SHOW_SNACKBAR', { text: 'Ocorreu um erro ao sincronizar as requisições', status: 'error' }));
    }
  },
  async sendRequisicoesPendentesAPI({ dispatch }) {
    const requisicoes = await requisicaoService.getRequisicoes();
    const requisicoesPendentes = requisicoes.filter(requisicao => !requisicao.id_requisicao);

    if (requisicoesPendentes && requisicoesPendentes.length) {
      await dispatch('sendRequisicoesAPI', requisicoesPendentes);
    }
  },
  async sendRequisicaoAPI({ commit }, requisicao) {
    if (!requisicao.id_requisicao) {
      try {
        const response = await requisicaoService.sendRequisicaoAPI(requisicao);
        requisicao.id_requisicao = Number(process.env.NODE_ENV === 'production' ? response.data.result.id_requisicao : response.data.id_requisicao);
        await requisicaoService.updateRequisicao(requisicao);
        commit('UPDATE_REQUISICAO', requisicao);
      } catch (error) {
        console.log(error);
        commit('SHOW_SNACKBAR', { text: error, status: 'error' });
        return error;
      }
    }
  },
  async fetchRequisicoes({ commit }) {
    try {
      commit('SET_LOADING', true);
      const response = await requisicaoService.getRequisicoes();
      commit('SET_REQUISICAOS', response);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      commit('SET_LOADING', false);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async createRequisicao({ commit }, { idEmpresaProducao, idProducao, qtdePrevista, idEstoqueSaida, idEstoqueEntrada, idRequisitante, idResponsavel }) {
    const requisicao = new Requisicao();
    
    requisicao.id_empresa_producao = idEmpresaProducao;
    requisicao.id_producao = idProducao;
    requisicao.qtde_prevista = qtdePrevista;
    requisicao.id_estoque_saida = idEstoqueSaida;
    requisicao.id_estoque_entrada = idEstoqueEntrada;
    requisicao.id_requisitante = idRequisitante;
    requisicao.id_responsavel = idResponsavel;

    try {
      const id = await requisicaoService.addRequisicao(requisicao);
      requisicao.id_interno = id;
      commit('SET_REQUISICAO', requisicao);
      return requisicao.id_interno;
      // router.push({ name: 'Requisicao', params: { id: requisicao.id_interno }});
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async addItemRequisicao({ commit }, { idRequisicao, item }) {
    const itemRequisicao = new ItemRequisicao();

    itemRequisicao.id_requisicao = idRequisicao;
    itemRequisicao.id_produto = item.id_produto;
    itemRequisicao.id_unidade = item.id_unidade;
    itemRequisicao.unidade = item.unidade;
    itemRequisicao.produto = item.descricao;
    itemRequisicao.qtde_unidade = item.qtde_unidade;
    itemRequisicao.lote_padrao = item.lote_padrao;

    const updRequisicao = await requisicaoService.addItemRequisicao(idRequisicao, itemRequisicao);
    commit('UPDATE_REQUISICAO', updRequisicao);
    return updRequisicao.id_interno;
  },
  async updateRequisicao({ commit }, updRequisicao) {
    await requisicaoService.updateRequisicao(updRequisicao);
    commit('UPDATE_REQUISICAO', updRequisicao);
  },
  async deleteRequisicao({ commit }, id) {
    try {
      await requisicaoService.deleteRequisicao(id);
      commit('DELETE_REQUISICAO', id);
      // router.push({ name: 'Home' });
      commit('SHOW_SNACKBAR', { text: 'Registro excluído com sucesso.', status: 'success' });
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async deleteRequisicoes({ commit, dispatch }, requisicoes) {
    if (confirm(`Deseja excluir ${requisicoes.length} registros?`)) {
      for (const requisicao of requisicoes) {
        await dispatch('deleteRequisicaoSilent', requisicao.id_interno);
      }
      commit('SET_REQUISICAOS_SELECTED', []);
      commit('SHOW_SNACKBAR', { text: 'Operação concluída com sucesso', status: 'success' });
    } else {
      return;
    }
  },
  async deleteRequisicaoSilent({ commit }, id) {
    try {
      await requisicaoService.deleteRequisicao(id);
      commit('DELETE_REQUISICAO', id);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  selectAllRequisicoes({ state, commit }) {
    commit('SET_REQUISICAOS_SELECTED', state.requisicoes);
  },
  clearRequisicoesSelected({ commit }) {
    commit('SET_REQUISICAOS_SELECTED', []);
  }
};

const mutations = {
  SET_REQUISICAOS: (state, requisicoes) => state.requisicoes = requisicoes,
  SET_REQUISICAO: (state, requisicao) => state.requisicoes.push(requisicao),
  SET_REQUISICAOS_SELECTED: (state, selected) => state.selected = selected,
  UPDATE_REQUISICAO: (state, updRequisicao) => {
    const index = state.requisicoes.findIndex(requisicao => requisicao.id_interno === updRequisicao.id_interno);
    if (index !== -1) state.requisicoes.splice(index, 1, updRequisicao);
  },
  DELETE_REQUISICAO: (state, id) => state.requisicoes = state.requisicoes.filter(requisicao => requisicao.id_interno !== id)
};

export default {
  state,
  getters,
  actions,
  mutations
}